import React from 'react';

import clsx from 'clsx';
import CloseButton from './close_button';

import '../../www/assets/css/time_rate_controls.css';
import MinusButtonSVG from '../../www/assets/images/icon_minus.svg';
import PlusButtonSVG from '../../www/assets/images/icon_plus.svg';
import ar from '../languages/ar';
import { refsStore, timeStore } from '../managers/globalState';

/**
 * @typedef Props
 * @prop {string} content
 */

class TimeRateControls extends React.Component {
	/**
	 * Constructs the component.
	 * @param {Props} props
	 */
	constructor(props) {
		super(props);

		const { rate } = timeStore.stateSnapshot;

		this.state = {
			open: props.open,
			selected: rate === 1 ? 'real-rate' : 'default-rate'
		};

		this.close = this.close.bind(this);
		this.toggle = this.toggle.bind(this);
		this._update = this._update.bind(this);
		this._handleSelection = this._handleSelection.bind(this);
	}

	componentDidMount() {
		this.fRateUnsubscribe = timeStore.subscribeTo('formattedRate', () => this.forceUpdate());
	}

	componentWillUnmount() {
		typeof this.fRateUnsubscribe === 'function' && this.fRateUnsubscribe();
	}

	_update(event) {
		if (event.detail) {
			this.setState(event.detail);
		}
	}

	_update(poi) {
		if (poi.detail) {
			this.setState(poi.detail);
		}
	}

	_update(gmap) {
		if (gmap.detail) {
			this.setState(gmap.detail);
		}
	}

	_handleSelection(event) {
		const id = event.currentTarget.id;
		this.setState({ selected: id }, () => {
      const { get } = refsStore.stateSnapshot;
			if (id === 'real-rate') {
				get('time').setRealTime();
			} else {
				get('time').setDefaultTime();
			}
		});
	}

	_handleSelection(poi) {
		const id = poi.currentTarget.id;
		this.setState({ selected: id }, () => {
      const { get } = refsStore.stateSnapshot;
			if (id === 'real-rate') {
				get('time').setRealTime();
			} else {
				get('time').setDefaultTime();
			}
		});
	}

	_handleSelection(gmap) {
		const id = gmap.currentTarget.id;
		this.setState({ selected: id }, () => {
      const { get } = refsStore.stateSnapshot;
			if (id === 'real-rate') {
				get('time').setRealTime();
			} else {
				get('time').setDefaultTime();
			}
		});
	}

	render() {
		const { open, selected } = this.state;
		const { formattedRate: { rate, unit } } = timeStore.stateSnapshot;
		if (!open) {
			return null;
		}
		const { isMobile } = this.props;
		const { get } = refsStore.stateSnapshot;
		const time = get('time');
		const currentTimeIndex = time._currentIndex;
		const timeRatesLength = time._rates.length;

		const minusButtonSVG = <MinusButtonSVG />;
		const plusButtonSVG = <PlusButtonSVG />;
		

		return (
			<div className='time-rate-container'>
				<div className='title-container'>{ar.satellite_time_rate}</div>
				{isMobile
					? (
						<div className='controls-container'>
							<button
								id='real-rate'
								className={'rate-button' + (selected === 'real-rate' ? ' selected' : '')}
								onClick={this._handleSelection}
							>
							{ar.real_time}
							</button>
							<button
								id='default-rate'
								className={'rate-button' + (selected === 'default-rate' ? ' selected' : '')}
								onClick={this._handleSelection}
							>
								30 sec/sec
							</button>
						</div>
					)
					: (
						<div className='controls-container'>
							<a className={clsx('controls-button', 'mx-1', currentTimeIndex > 0 && 'active')} onClick={time.decreaseRate}>
								{minusButtonSVG}
							</a>
							<a className={clsx('controls-button', 'mx-1', currentTimeIndex < timeRatesLength - 1 && 'active')} onClick={time.increaseRate}>
								{plusButtonSVG}
							</a>
							<p className='current'>
								<span className='display-value'>{rate}</span>
								<span className='display-units'>{unit}</span>
							</p>
							<button
								className='rate-button no-select'
								onClick={time.setRealTime}
							>
							{ar.real_time}
							</button>
						</div>
					)}
				{!isMobile && (
					<CloseButton size='small' onClick={this.close} />
				)}
			</div>
		);
	}

	close() {
		const { closeTimeControls, closeTimeControlsVisible } = this.props;
		this.setState({ open: false });
		closeTimeControls(!closeTimeControlsVisible);
	}

	toggle() {
		const { open } = this.state;
		this.setState({ open: !open });
	}
}

export default TimeRateControls;
